import * as Yup from 'yup';

export const administrationSettingSchema = Yup.object().shape({
    furtherAssignmentCheckDaysBaseEmployee: Yup.number().required(),
    furtherAssignmentCheckDaysBaseAgency: Yup.number().required(),
});